import * as Sentry from '@sentry/react';
import env from '~/env';

type CaptureContext = {
  extra?: Record<string, unknown>;
  level?: Sentry.SeverityLevel;
  tags?: Record<string, string>;
};

export function logError(error: Error, context?: CaptureContext) {
  if (env.VITE_NODE_ENV === 'dev') {
    // eslint-disable-next-line no-console -- only applies in non-production environments
    console.error('Error logged:\n', error, '\nContext:\n', context);
  }
  Sentry.captureException(error, context);
}

export function logMessage(
  message: string,
  context?: CaptureContext | Sentry.SeverityLevel,
) {
  if (env.VITE_NODE_ENV === 'dev') {
    // eslint-disable-next-line no-console -- only applies in non-production environments
    console.info('Message logged:\n', message, '\nContext:\n', context);
  }
  Sentry.captureMessage(message, context);
}

export function addBreadcrumb(breadcrumb: Sentry.Breadcrumb) {
  if (env.VITE_NODE_ENV === 'dev') {
    // eslint-disable-next-line no-console -- only applies in non-production environments
    console.info('Breadcrumb added:\n', breadcrumb);
  }
  Sentry.addBreadcrumb(breadcrumb);
}

type IdentifyUserParams = {
  email: string;
  storeName: string;
  storeId: number;
  orderNo: string;
  orderIdFromPlatform: string;
  appType: 'GSP' | 'CREW';
};

export function identifyUser(params: IdentifyUserParams) {
  try {
    if (env.VITE_NODE_ENV === 'prod') {
      const {
        email,
        storeId,
        storeName,
        appType,
        orderIdFromPlatform,
        orderNo,
      } = params;

      Sentry.setUser({
        email,
        username: email,
      });

      Sentry.setTag('storeName', storeName);
      Sentry.setTag('storeId', storeId.toString());
      Sentry.setTag('appType', appType);
      Sentry.setTag('orderIdFromPlatform', orderIdFromPlatform);
      Sentry.setTag('orderNo', orderNo);
    }
  } catch (error) {
    logError(
      error instanceof Error ? error : (
        new Error('Failed to identify user', { cause: error })
      ),
    );
  }
}
